import React from "react";
import { Card, Space, Tag, Typography } from "antd";
import "./PublicationCard.css";
import { Publication } from "../api/publications.model";

import "./PublicationCard.css";

export interface PublicationCardProps {
  publication: Publication;
  onClick?(): void;
}

function typeToTag(type: string) {
  switch (type) {
    case "journal":
      return <Tag>Journal Article</Tag>;
    case "conference":
      return <Tag>Conference</Tag>;
    case "dataset":
      return <Tag>Dataset</Tag>;
  }
}

function accessToTag(access: string) {
  switch (access) {
    case "open":
      return <Tag color="green">Open Access</Tag>;
    case "embargoed":
      return <Tag color="orange">Embargoed</Tag>;
    default:
      return <Tag>{access}</Tag>;
  }
}

export const PublicationCard: React.FC<PublicationCardProps> = ({
  publication,
  onClick,
}) => {
  let target: string | null = null;
  if (publication.recordType !== "dataset") {
    if (publication.record.files?.length > 0) {
      target = publication.record.files[0].links.self;
    }
  }

  const grantTags = publication.record.metadata.grants?.map((grant) => (
    <Tag key={grant.code}>Funded by {grant.acronym}</Tag>
  ));

  const accessTag = accessToTag(publication.record.metadata.access_right);

  return (
    <Card
      className="publication-view"
      title={
        <Space className="publication-view-title" direction="vertical">
          <Typography.Title level={2}>
            {publication.title}
            {}
          </Typography.Title>
          <div className="publication-tags">
            {accessTag}
            {typeToTag(publication.recordType)}
            <Tag>
              Published on {publication.publicationDate.substring(0, 10)}
            </Tag>
            {grantTags}
          </div>
        </Space>
      }
      hoverable={target !== null}
      onClick={() => {
        if (target) {
          window.open(target, "_blank");
        }
      }}
    >
      <div className="publication-view-content">
        <div className="publication-view-authors">
          {publication.authors.join(", ")}
        </div>
        <Typography.Paragraph
          ellipsis={{ rows: 4, expandable: false }}
          className="publication-view-abstract"
        >
          {publication.description}
        </Typography.Paragraph>
      </div>
    </Card>
  );
};
